import { CATEGORIAS_DOCUMENTO, CATEGORIAS_PUBLICACAO } from './publicacao.definitions';
import type { Publicacao } from './publicacao.types';

export interface OpcaoFiltro {
  valor: string;
  label: string;
}

/**
 * Pílulas de filtro só das categorias que têm algo publicado (pra não dar a sensação de
 * "vazio"), na ordem do catálogo; "Todas/Todos" só quando há mais de uma categoria.
 */
export function opcoesComConteudo(catalogo: readonly OpcaoFiltro[], presentes: Set<string>, rotuloTodas: string): OpcaoFiltro[] {
  const opcoes = catalogo.filter((c) => presentes.has(c.valor));
  return opcoes.length > 1 ? [{ valor: '', label: rotuloTodas }, ...opcoes] : opcoes;
}

/** Filtro em vigor: se a escolhida sumiu (ou só existe uma categoria), cai no padrão. */
export function filtroEfetivo(escolhido: string, opcoes: readonly OpcaoFiltro[]): string {
  if (opcoes.some((o) => o.valor === escolhido)) return escolhido;
  return opcoes.length === 1 ? opcoes[0].valor : '';
}

/** Filtro do feed da Início: a própria categoria, de post ou de documento (sem um "Documentos"
 * genérico) — uma política documento cai no mesmo filtro "Políticas" dos posts. */
export function filtroDoFeed(p: Pick<Publicacao, 'tipo' | 'categoria'>): string {
  return p.categoria;
}

/** Catálogo do feed: categorias de post e, depois, as que só existem em documento (mesmo valor =
 * mesmo filtro, ex.: Políticas). */
export const CATALOGO_FILTRO_FEED: readonly OpcaoFiltro[] = [
  ...CATEGORIAS_PUBLICACAO.map((c) => ({ valor: c.valor as string, label: c.label })),
  ...CATEGORIAS_DOCUMENTO.filter((d) => !CATEGORIAS_PUBLICACAO.some((c) => c.valor === d.valor)).map((d) => ({
    valor: d.valor as string,
    label: d.label,
  })),
];

export const CATALOGO_FILTRO_DOCUMENTOS: readonly OpcaoFiltro[] = CATEGORIAS_DOCUMENTO.map((c) => ({ valor: c.valor as string, label: c.label }));
